<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @checkSubmit="checkSubmit"
            @goBackService="goBackService"
        >
            <template #content>
                <ChangeBeforeAfter :title="showData?.payCodeName">
                    <template #subtitle>
                        <p class="font-bold text-black mb-2">
                            <template v-if="isAplCatlPayAcc()">
                                要保人： {{ showData.beneFiName }} {{ showData?.before?.beneFiId }}
                            </template>
                            <template v-else>
                                受益人： {{ showData?.beneFiName }}
                            </template>
                        </p>
                    </template>
                    <template #before>
                        <div class="pt-0.5 divide-y divide-dashed divide-gray-200 lg:divide-y-0 lg:grid grid-cols-6">
                            <div class="outter-row">
                                <div class="table-header">
                                    <template v-if="isAplCatlPayAcc()">
                                        戶名
                                    </template>
                                    <template v-else>
                                        ID
                                    </template>
                                </div>
                                <div class="content">
                                    <template v-if="isAplCatlPayAcc()">
                                        {{ showData.beneFiName ? showData.beneFiName : '未留存' }}
                                    </template>
                                    <template v-else>
                                        {{ showData?.before?.beneFiId ? showData?.before?.beneFiId: '未留存ID' }}
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="showData?.foreignAccount"
                                class="outter-row"
                            >
                                <div class="table-header">
                                    英文戶名
                                </div>
                                <div class="content">
                                    {{ showData?.before?.bankAccountName ? showData?.before?.bankAccountName: '未指定' }}
                                </div>
                            </div>
                            <div
                                class="outter-row col-span-3"
                                :class="[showData?.foreignAccount ?'':'lg:pl-10']"
                            >
                                <div class="table-header">
                                    銀行
                                </div>
                                <div class="content">
                                    <template v-if="showData?.before?.headBankNo">
                                        {{ showData?.before?.headBankNo }}{{ showData?.before?.branchBankNo }} {{ showData?.before?.headBankName }}
                                    </template>
                                    <template v-else>
                                        未指定
                                    </template>
                                </div>
                            </div>
                            <div class="outter-row">
                                <div class="table-header">
                                    帳號
                                </div>
                                <div class="content">
                                    {{ showData?.before?.bankAccount ? showData?.before?.bankAccount: '未指定' }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #after>
                        <div class="pt-0.5 divide-y divide-dashed lg:divide-y-0 divide-gray-200 text-gray-900 lg:grid grid-cols-6">
                            <div class="outter-row">
                                <div class="table-header">
                                    <template v-if="isAplCatlPayAcc()">
                                        戶名
                                    </template>
                                    <template v-else>
                                        ID
                                    </template>
                                </div>
                                <div class="content">
                                    <template v-if="isAplCatlPayAcc()">
                                        {{ showData.beneFiName ? showData.beneFiName : '未留存' }}
                                    </template>
                                    <template v-else>
                                        {{ showData?.after?.beneFiId ? showData?.after?.beneFiId: '未留存ID' }}
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="showData?.foreignAccount"
                                class="outter-row"
                            >
                                <div class="table-header">
                                    英文戶名
                                </div>
                                <div class="content">
                                    {{ showData?.after?.bankAccountName }}
                                </div>
                            </div>
                            <div
                                class="outter-row col-span-3"
                                :class="[showData?.foreignAccount ?'':'lg:pl-10']"
                            >
                                <div class="table-header">
                                    銀行
                                </div>
                                <div class="content">
                                    {{ showData?.foreignAccount ? `${showData?.after?.headBankNo} ${showData?.after?.headBankName}`: `${showData?.after?.branchBankNo} ${showData?.after?.branchBankName}` }}
                                </div>
                            </div>
                            <div class="outter-row">
                                <div class="table-header">
                                    帳號
                                </div>
                                <div class="content">
                                    {{ showData?.after?.bankAccount }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ChangeBeforeAfter>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRefs, reactive, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';
import routeName from '@/router/constant.js';
import { getResult } from '@/apis/system';
import { isAplCatlPayAcc } from '@/utils/is/aplCatlUtils.js';

export default {
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter
    },
    props: {
        // result: {
        //     type: Object,
        //     required: true,
        // }
    },
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const aplCatl = computed(() => store.state.permissions.aplCatl);

        const data = reactive({
            showData: {

            }
        });
        const code = ref(aplCatl.value);
        const checkSubmit = () => {
            const page = routeName.PAYACC_FINISH;
            router.push({ name: page });
        };
        const goBackService = () => {
            router.push({ name: route.meta.backPage });
        };
        // 進入點
        const getResultData = () => {
            getResult().then(res => {
                data.showData = res.data.externalPayAcc;
            });
        };
        getResultData();
        return {
            ...toRefs(data),
            code,
            goBackService,
            checkSubmit,
            isAplCatlPayAcc
        };
    },
};
</script>
<style scoped lang="scss">
.outter-row {
    @apply flex pt-2 pb-1 lg:pt-0 lg:first:pl-10;
    &:first-child {
        @apply pt-0;
    }
}
.table-header {
    @apply text-sm leading-6 xs:leading-7 w-20 flex-shrink-0 lg:hidden py-1;
}
.content {
    @apply text-base xs:text-lg leading-6 xs:leading-7 py-1;
}
</style>
